import { createFileRoute } from "@tanstack/react-router";

import { PublishTikTokScreen } from "@/features/publish-tiktok/screens/PublishTikTokScreen";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/publish/tiktok/$tiktokAccountId/$mediaId",
)({
  component: PublishTikTokRoute,
});

function PublishTikTokRoute() {
  const { tiktokAccountId, mediaId } = Route.useParams();
  return (
    <PublishTikTokScreen tiktokAccountId={tiktokAccountId} mediaId={mediaId} />
  );
}
